<template>
    <div class="main-content">
        <div class="text-center">
            <pulse-loader :loading="loading" :color="color"/>
        </div>

        <div class="card" v-if="calls && !loading">
            <div class="card-body">
                <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                        <a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#action_req" role="tab" aria-controls="nav-home" aria-selected="true">Требующие действий</a>
                        <a class="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#no_action_req" role="tab" aria-controls="nav-profile" aria-selected="false">Ознакомление</a>
                    </div>
                </nav>

                <div class="tab-content bg-gray" id="nav-tabContent">
                    <div class="tab-pane fade show active" id="action_req" role="tabpanel" aria-labelledby="nav-home-tab">

                        <template v-if="!calls.action_req.length">
                            <div class="text-center">
                                <p><h4>Нет задач требующих действий</h4></p>
                            </div>
                        </template>
                        <template v-else>
                            <div class="card" v-for="(task) in calls.action_req">
                                <div class="card-body">
                                    <CabinOrdersRunnerTable :orders="[task.order]" :task="task" type="viewOrder"/>
                                    <taskActions :type="task.type" :task="task" :inStores="inStores" :runners="runners" @updateTasks="updateTasks"/>
                                </div>
                            </div>
                        </template>

                    </div>
                    <div class="tab-pane fade" id="no_action_req" role="tabpanel" aria-labelledby="nav-home-tab">

                        <template v-if="!calls.no_action_req.length">
                            <div class="text-center">
                                <p><h4>Нет задач для ознакомления</h4></p>
                            </div>
                        </template>
                        <template v-else>
                            <div class="card" v-for="(task) in calls.no_action_req">
                                <div class="card-body">
                                    <CabinOrdersRunnerTable :orders="[task.order]" :task="task" type="viewOrder"/>
                                    <taskActions :type="task.type" :task="task" :inStores="inStores" :runners="runners" @updateTasks="updateTasks"/>
                                </div>
                            </div>
                        </template>

                    </div>
                </div>
            </div>
        </div>

<!--        <div class="row">-->
<!--            <div class="col-md-12" v-if="!calls && !loading && false">-->
<!--                <h5>Задач не найдено</h5>-->
<!--            </div>-->
<!--            <div class="col-md-12" v-for="(callRequest, index) in calls" :key="index">-->
<!--                <div class="card">-->
<!--                    <div class="card-header">-->
<!--                        <h5>{{callRequest.user.name}}</h5>-->
<!--                    </div>-->
<!--                    <div class="card-body bg-gray">-->
<!--                        <div v-if="callRequest.tasks" v-for="(task, index2) in callRequest.tasks" :key="index2">-->

<!--                            <div class="card">-->
<!--                                <div class="card-body">-->
<!--                                    <CabinOrdersRunnerTable :orders="[task.order]" :task="task" type="viewOrder"/>-->

<!--                                    <div>-->
<!--                                        <div class="row">-->
<!--                                            <div class="col-md-12">-->
<!--                                                <taskActions :type="task.type" :task="task" :inStores="inStores" :runners="runners" @updateTasks="updateTasks"/>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->

<!--                                </div>-->

<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>


<script>

    import api from '@/api'
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    import CabinOrdersRunnerTable from '@/views/components/runners/cabinOrdersRunnersTable'
    import taskActions from '@/views/components/runners/taskActions'

    export default {
        components: {
            PulseLoader,
            CabinOrdersRunnerTable,
            taskActions
        },
        data() {
            return {
                loading: true,
                color: '#5BBFDE',
                calls: null,
                runners: null,
                inStores: null,
            }
        },
        methods: {
            async getTasks() {
                let {data} = await api.index('/runners/getOrderTasks');
                this.calls = data.tasks;
                this.runners = data.runners;
                this.inStores = data.in_stores;
                this.loading = false;
            },
            async updateTasks(id, action) {
                this.calls = null;
                await this.getTasks();
                return;

                if (action == 3 || action == 2 || action == 4 || action == 5) {
                    // this.calls.action_req.forEach((c, i) => {
                        // this.calls[i].tasks = this.calls[i].tasks.filter((t) => {
                        //     if (t.id == id) {
                        //         return false;
                        //     } else {
                        //         return true;
                        //     }
                        // });
                        this.calls.action_req = this.calls.action_req.filter((t) => t.id != id);
                    // })
                    // this.calls.action_req.forEach((c, i) => {
                        this.calls.no_action_req = this.calls.no_action_req.filter((t) => t.id != id);

                }
            }
        },
        mounted() {
            this.getTasks();
        }

    }

</script>

<style>
    #nav-tabContent{
        padding:20px;
        /*background-color: #b4b4b4;*/
    }
    .bg-gray {
        background-color: #e9ecef;
    }
    .p-t-20{
        padding-top: 20px;
    }
    .nav-item.nav-link.active {
        border: 1px solid #343A52;
        background: #343A52;
        color: #fff;
    }
</style>
